import { CommonServicesEndpoints } from '../../../baseAppConfig.types';
import { DefaultThemeSpecificServicesEndpoints } from '../../config.types';

const prodEndpoints: CommonServicesEndpoints & DefaultThemeSpecificServicesEndpoints = {
  wmsConfigurationServiceBasePath: 'https://services.sentinel-hub.com',
  identityServiceBasePath: 'https://services.sentinel-hub.com/ims',
  rateLimitSupervisorServiceBasePath: 'https://services.sentinel-hub.com',
  dashboardServiceBasePath: 'https://services.sentinel-hub.com',
  accountingServiceBasePath: 'https://services.sentinel-hub.com',
  ogcServiceBasePath: 'https://services.sentinel-hub.com',
  accessControlServiceBasePath: 'https://services.sentinel-hub.com',
  tpdiServiceBasePath: 'https://services.sentinel-hub.com',
  managementServiceBasePath: 'https://services.sentinel-hub.com',

  byocGlobalServiceBasePath: 'https://services.sentinel-hub.com',
  byocEuCentralServiceBasePath: 'https://services.sentinel-hub.com',
  byocUsWestServiceBasePath: 'https://services-uswest2.sentinel-hub.com',
  byocCreodiasServiceBasePath: 'https://creodias.sentinel-hub.com',
  byocCodeDeServiceBasePath: 'https://code-de.sentinel-hub.com',
  usWestWmsServiceBasePath: 'https://services-uswest2.sentinel-hub.com',
  creodiasWmsServiceBasePath: 'https://creodias.sentinel-hub.com',
  byocSgsHqServiceBasePath: '',
  defaultWmsInstanceBaseUrl: 'https://services.sentinel-hub.com',
};
export default prodEndpoints;
